import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import './fonts/montserrat.css';

export default function Theme(companyData) {
  // Definindo as cores da paleta
  const palette = {
    primary: {
      main: companyData.primary_color,
      lighter: `${companyData.primary_color}44`,
    },
    secondary: {
      main: companyData.secondary_color,
      lighter: `${companyData.secondary_color}44`,
    },
    global: {
      white: '#FAFAFA',
      black: '#000000',
      gray: '#434242',
      lightgray: '#747474',
    },
  };

  let theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 640,
        md: 1024,
        lg: 1200,
        xl: 1900,
      },
    },
    typography: {
      fontFamily: 'montserrat, sans-serif',
      h1: {
        fontSize: '1.4rem',
        fontWeight: 600,
      },
      h2: {
        fontSize: '1.2rem',
        fontWeight: 600,
      },
      h3: {
        fontSize: '1.05rem',
        fontWeight: 500,
      },
      h4: {
        fontSize: '0.8rem',
        fontWeight: 700,
      },
      h5: {
        fontSize: '0.8rem',
        fontWeight: 600,
      },
      h6: {
        fontSize: '0.7rem',
        fontWeight: 600,
      },
      subtitle1: {
        fontSize: '1.05rem',
        fontWeight: 700,
      },
      subtitle2: {
        fontSize: '0.7rem',
        fontWeight: 700,
      },
      body1: {
        fontSize: '0.8rem',
        fontWeight: 400,
      },
      body2: {
        fontSize: '0.7rem',
        fontWeight: 500,
      },
      caption: {
        fontSize: '0.6rem',
        fontWeight: 400,
      },
      overline: {
        fontSize: '0.6rem',
        fontWeight: 600,
      },
    },
    palette,
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            '&.Mui-focused': {
              color: palette.primary.main,
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: palette.secondary.main,
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: 'inherit',
          },
          text: {
            '&:hover': {
              backgroundColor: palette.primary.lighter,
            },
          },
          containedSecondary: {
            minWidth: '200px',
            '&:disabled': {
              backgroundColor: palette.global.lightgray,
              color: palette.global.white,
            },
          },
        },
      },
    },
  });

  theme = responsiveFontSizes(theme);

  return theme;
}
